import { Icon } from 'components/Icon';
import { useEffect, useState } from 'react';
import { LogoSpinner } from 'screens/Dashboard/Home/styled';
import { ProposalSteps } from 'screens/EproposalConfirm/ProposalSteps';
import {
  ConfirmDisplayContainer,
  ConfirmDisplayWrapper,
} from 'screens/EproposalConfirm/styled';
import { Title } from 'ui/styled';
import { theme } from 'ui/theme-color';

export const EProposalInvalidToken = ({ isMobile }) => {
  const [fontLoaded, setFontLoaded] = useState(false);

  useEffect(() => {
    document.fonts.load('24px "Material Symbols Outlined"').then(() => {
      setFontLoaded(true);
    });
  }, []);

  const spinnerImagePath = '/images/circulo_tes2.svg';

  return fontLoaded ? (
    <ConfirmDisplayWrapper isMobile={isMobile}>
      <ConfirmDisplayContainer>
        <Icon name={'Cancel'} size={80} color={theme.palette.error.main} fill />
        <span
          style={{
            textAlign: 'text',
            width: '60%',
          }}
        >
          <Title centred>Token Inválido!</Title>
          <p
            style={{
              margin: 0,
            }}
          >
            O link utilizado não é válido ou já expirou.
          </p>
        </span>

        {!isMobile && (
          <ProposalSteps
            icon1={{
              name: 'circle_circle',
              color: theme.palette.colors.lightgrey,
              fill: false,
            }}
            icon2={{
              name: 'circle_circle',
              color: theme.palette.colors.lightgrey,
              fill: false,
            }}
            icon3={{
              name: 'circle_circle',
              color: theme.palette.error.main,
              fill: false,
            }}
          />
        )}
        <div
          style={{
            display: 'grid',
            gap: isMobile && '1rem',
            gridTemplateColumns: !isMobile && '1fr auto 1fr',
          }}
        >
          {!isMobile && (
            <>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Icon
                  name={'upload'}
                  size={36}
                  fill
                  color={theme.palette.colors.lightgrey}
                />
                <div
                  style={{
                    width: '65%',
                  }}
                >
                  <Title small nomargin centred>
                    Proposta Enviada
                  </Title>
                  <p>Recebemos sua proposta com sucesso!</p>
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Icon
                  name={'Schedule'}
                  size={36}
                  color={theme.palette.colors.lightgrey}
                />
                <div
                  style={{
                    width: '65%',
                  }}
                >
                  <Title small nomargin centred>
                    Em Análise
                  </Title>
                  <p>
                    Nossa equipe está analisando os detalhes de sua proposta.
                  </p>
                </div>
              </div>
            </>
          )}

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Icon name={'call'} size={36} color={theme.palette.error.main} />
            <div
              style={{
                width: '65%',
              }}
            >
              <Title small nomargin centred>
                Contato
              </Title>
              <p>Entre em contato com seu distribuidor.</p>
            </div>
          </div>
        </div>
      </ConfirmDisplayContainer>
    </ConfirmDisplayWrapper>
  ) : (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <LogoSpinner src={spinnerImagePath} alt="Logo rotativo" />
    </div>
  );
};
